
// TinyMCE imports
import "tinymce/tinymce"
import "tinymce/themes/silver";
import "tinymce/icons/default";
import 'tinymce/models/dom/model'
import 'tinymce/skins/ui/oxide/skin.css';
// TinyMCE plugin imports
import 'tinymce/plugins/emoticons';
import 'tinymce/plugins/emoticons/js/emojis';
import 'tinymce/plugins/autoresize';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/autolink';

import Editor from '@tinymce/tinymce-vue'
import { computed, ref, onMounted } from "vue"
import { useStore } from "vuex"
import AttachmentsViewer from "../AttachmentsViewer/AttachmentsViewer.vue";
import AttachmentsEditor from "../AttachmentsEditor/AttachmentsEditor.vue";

export default {
    name: "PostComment",
    components: {
        Editor,
        AttachmentsEditor,
        AttachmentsViewer
    },
    props: {
        comment: {
            type: Object,
            required: true
        },
        canReply: {
            type: Boolean,
            default: false
        },
        subComments: {
            type: Array,
            default: []
        },
        postId: {
            type: String
        },
        groupId: {
            type: String
        },
        isFrivilligContext: {
            type: Boolean,
            default: false
        }
    },

    setup(props){
        const store = useStore()

        const editCommentContent = ref(props.comment.content)
        const editCommentFilesToAdd = ref([])
        const editCommentFilesToRemove = ref([])
        
        const subCommentContent = ref('')
        const subCommentFilesToAdd = ref([])

        const isAddingSubcomment = ref(false)
        const isEditingComment = ref(false)
        const addSubCommentRef = ref(null)
        const userInfoExpanded = ref(false)

        const isSubmitting = ref(false)
        const subCommentSubmitButtonDisabled = computed(() => subCommentContent.value.length === 0 || isSubmitting.value)

        const overlayContent = props.isFrivilligContext
        ? "MemberOverlayProfileCard"
        : "MemberOverlay" 
        
        const handleEditComment = () => {
            isEditingComment.value = true
        }

        const handleCancelEditedComment = () => {
            isEditingComment.value = false
        }

        const handleSaveEditedComment = async () => {

            const formData = new FormData()

            if (editCommentContent.value) {
                formData.append('htmlComment', editCommentContent.value)
            }
            
            editCommentFilesToAdd.value.forEach(file => {
                formData.append('filesToAdd', file)
            })

            editCommentFilesToRemove.value.forEach(fileId => {
                formData.append('filesToRemove', fileId)
            })

            const response = await store.dispatch('forum/submitEditComment', {
                id: props.comment.id,
                body: formData
            })

            if (response.status === "success") {
                isEditingComment.value = false
            }
        }

        const handleDeleteComment = (e) => {
            store.commit('main/set_page_overlay_content_data', {
                callback: async () => {
                    if(isSubmitting.value){                
                        return;
                    }          
                    isSubmitting.value = true
                    var response = await store.dispatch('forum/submitDeleteComment', { id: props.comment.id })                    
                    if (response.success) {
                        location.reload()
                    } else {
                        isSubmitting.value = false
                    }
                }
            })

            store.dispatch("main/openPageOverlay", {
                overlayContent: "DeleteCommentOverlay",
                returnTarget: e.currentTarget,
            });
        }

        const scrollToAddSubComment = () => {
            isAddingSubcomment.value = true
            setTimeout(() => {
                addSubCommentRef.value?.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
            }, 100)
        }

        const submitNewSubComment = async () => {

            if (!subCommentContent.value) {
                return
            }
           

            isSubmitting.value = true
            
            let formData = new FormData()
            formData.append('postId', props.postId)
            formData.append('htmlComment', subCommentContent.value)

            subCommentFilesToAdd.value.forEach(file => {
                formData.append('file', file)
            })
            await store.dispatch('forum/submitNewSubComment', {
                id: props.comment.id,
                body: formData
            })
            await store.dispatch("forum/getPostComments", {
                postId: props.postId,
                pageId: store.state.main.page_id
            })

            sessionStorage.setItem("scrollPosition", window.scrollY);
            subCommentContent.value = ""
            isSubmitting.value = false

        }

 
      
        
        
        const startUserInfoOverlay = (e) => {

            if (props?.comment?.authorId == undefined){
                return
            }

            store.commit('main/set_page_overlay_content_data', { 
                userId: props?.comment?.authorId,
                isFrivilligContext: props.isFrivilligContext })

            store.dispatch("main/openPageOverlay", {
                overlayContent: overlayContent,
                returnTarget: e.currentTarget,
            })
        }

        const getLabel = (labelKey) => store.getters['labels/getLabel']({labelCollection: 'PostCommments', labelKey})

        return {
            getLabel,
            handleEditComment,
            handleDeleteComment,
            submitNewSubComment,
            handleSaveEditedComment,
            handleCancelEditedComment,
            startUserInfoOverlay,
            scrollToAddSubComment,
            editCommentContent,
            editCommentFilesToAdd,
            editCommentFilesToRemove,
            subCommentContent,
            subCommentFilesToAdd,
            isAddingSubcomment,
            isEditingComment,
            addSubCommentRef,
            userInfoExpanded,
            subCommentSubmitButtonDisabled,
            isSubmitting
        }
    }
}